import {BigId, LobbyImage, UserSessionId} from '@colonist/types'

export interface SendGeneralActionData {
    action: GeneralAction
    payload: unknown
}

export enum GeneralServices {
    FriendService,
    NotificationService,
}

// number associated with status is priority, e.g. InGame > OnlineAndIdle; see OnlineFriendManager.getOnlineStatusFromUser
export enum OnlineStatus {
    Offline = 0,
    OnlineAndIdle = 1,
    InRoom = 2,
    InGame = 3,
}

export enum GeneralAction {
    RegisterToFriendService = 1,
    ChangeOnlineStatus = 2,
    GetAllFriendsOnlineStatus = 3,
    InviteFriendToRoom = 4,
    GetAllRoomInvitesReceived = 5,
    RespondToFriendRoomInvite = 6,
    GetNotifications = 7,
    MarkNotificationAsRead = 8,
    MarkAllNotificationsAsRead = 9,
    RegisterToNotificationService = 10,
}

export interface OnlineUserData {
    friends: BigId[]
    username: string
    sessionStatuses: SessionOnlineStatus[]
    userId: BigId
    icon: LobbyImage
}

export interface SessionOnlineStatus {
    sessionId: UserSessionId
    onlineStatus: OnlineStatus
    servicesRegisteredTo: GeneralServices[]
}

export interface FriendStatusData {
    username: string
    onlineStatus: OnlineStatus
    icon: LobbyImage
    userId: BigId
}

export interface FriendRoomInvite {
    roomId: string
    senderUserId: BigId
    senderUsername: string
    receiverUserId: BigId
    senderIcon: LobbyImage
    dateCreated: Date
}

export interface FriendRoomInviteNotificationData {
    roomId: string
    senderUsername: string
    senderUserId: BigId
    senderIcon: LobbyImage
    dateCreated: Date
}

export interface FriendRequestReceivedData {
    username: string
    dateCreated: Date
}

export interface RoomInviteResponse {
    roomId: string
    response: boolean
    responderUsername: string
    responderUserId: BigId
}

export interface InviteFriendToRoomData {
    receiverUserId: string
    roomId: string
}

export interface RespondToFriendRoomInviteData {
    roomId: string
    accept: boolean
    senderUserId: BigId
}

export interface UpdateOnlineStatusData {
    onlineFriendStatuses: FriendStatusData[]
    sendingAllFriends: boolean
}
